import { ForgotPassword } from 'components/forgot-password/ForgotPassword'
import { useRef, useState } from 'react'
import { useValidation } from 'hooks/useValidation'
import { useFetch } from 'services/useFetch'
import { API } from 'services/api'
import { Alert } from 'avo-ui'
import { FORGOT_PASSWORD_VALIDATION } from 'services/validation/forgotPasswordValidation'

const INIT_STATE = {
    email: null,
    recaptcha_token: null,
}

export const ForgotPasswordContainer = () => {
    const recaptchaRef = useRef()
    const [forgotPasswordDetail, setForgotPasswordDetail] = useState(INIT_STATE)
    const { fetching: postForgotPassword, isLoading } = useFetch(API.FORGOT_PASSWORD)
    const { validateForm, errorForm, clearErrorForm } = useValidation({
        form: forgotPasswordDetail,
        schema: FORGOT_PASSWORD_VALIDATION,
    })

    const onChangeForm = (e) => {
        const { name, value } = e
        setForgotPasswordDetail({ ...forgotPasswordDetail, [name]: value })
    }

    const onSubmit = () => {
        validateForm().then(() => {
            clearErrorForm()
            postForgotPassword(forgotPasswordDetail)
                .then(() => {
                    onChangeForm({ name: 'recaptcha_token', value: null })
                    recaptchaRef?.current?.reset()
                    return Alert({
                        icon: 'success',
                        title: 'Forgot Password !',
                        message: 'Request berhasil, silahkan cek email anda',
                    })
                })
                .catch(() =>
                    Alert({
                        icon: 'error',
                        title: 'Authentication Error !',
                        message: 'Data yang di inputkan tidak valid',
                    }),
                )
        })
    }

    const props = {
        recaptchaRef,
        forgotPasswordDetail,
        onChangeForm,
        errorForm,
        isLoading,
        onSubmit,
    }

    return <ForgotPassword {...props} />
}
